import { CustomerCompanyMessage } from '../../../types/CustomerCompanyMessage';
import { useToasts } from '../../cdl/Toast/useToasts';
import { updateCustomerDetails } from '../../common/api/clients/company.api';
import { queries } from '../../common/api/queryKeys/queries';
import { translate } from '../../common/helpers/translate.helper';
import { useOptimisticMutation } from '../../common/hooks/useOptimisticMutation';
import { queryClient } from '../../lib/queryClient';

interface UpdateCustomerDetailsVariables {
    id: string;
    customerData: CustomerCompanyMessage;
}

export const useCustomerAdminSettingsOptimisticMutation = (customerId: string) => {
    const { addErrorToast } = useToasts();

    return useOptimisticMutation<CustomerCompanyMessage, Error, UpdateCustomerDetailsVariables, CustomerCompanyMessage>(
        {
            mutationFn: updateCustomerDetails,
            optimisticUpdateOptions: {
                queryKey: queries.customers.detail(customerId).queryKey,
                optimisticUpdatesFn: ({ prevQueryData, variables }) => {
                    return {
                        ...prevQueryData,
                        ...variables.customerData,
                    };
                },
                invalidateQueryOnSuccess: false,
            },
            onError: () => {
                addErrorToast(translate('company.toasts.informationUpdateError'));
            },
            onSuccess: () => {
                queryClient.invalidateQueries({ queryKey: queries.customers._def });
            },
        }
    );
};
